import { render, staticRenderFns } from "./_PaperRegisterDialog.vue?vue&type=template&id=6f02d066&"
import script from "./_PaperRegisterDialog.vue?vue&type=script&lang=js&"
export * from "./_PaperRegisterDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports